import { z } from 'zod';

export const $CandidateRole = z.object({
  id: z.number(),
  name: z.string(),
  displayName: z.string(),
  permissions: z.array(z.string()),
});
